/**
 * Shared Tailwind class strings. Keeps the repeated button, input and table
 * styles in one place so they stay consistent.
 */

export const btn = {
  primary: 'bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-600',
  primaryLg: 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600',
  save: 'bg-green-500 text-white px-3 py-1 rounded text-sm hover:bg-green-600',
  saveLg: 'bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600',
  cancel: 'bg-gray-300 text-gray-700 px-3 py-1 rounded text-sm hover:bg-gray-400',
  danger: 'text-red-500 hover:text-red-700 text-xs',
  link: 'text-sm text-blue-600 hover:text-blue-800',
  muted: 'text-xs text-gray-500 hover:text-gray-700',
};

export const field = {
  input: 'border rounded px-3 py-2',
  inputInline: 'ml-2 border rounded px-2 py-1',
  inputSm: 'border rounded px-2 py-1 text-sm',
  textarea: 'w-full border rounded px-3 py-2 text-sm h-24',
  label: 'block text-sm font-medium mb-2',
  labelSm: 'block text-sm font-medium mb-1',
};

export const table = {
  cell: 'border p-2',
  cellHead: 'border p-2 text-left',
  head: 'p-2 text-left',
};

export const text = {
  hint: 'text-xs text-gray-500',
  hintTight: 'text-xs text-gray-500 mt-1',
};

export const card = 'border rounded p-4';
export const panel = 'p-4 bg-gray-50 rounded';
